<form class="box" [formGroup]="controlForm">
  <div class="row">
    <div class="col-12">
      <div class="row p-0">
        <div class="col-md-6 col-lg-3">
          <div class="form">
            <label for="" class="label"> Reporte desde </label>
            <app-calendar [controlForm]="dateFromReport"></app-calendar>
            <app-error-message [text]="controlDateStartError"></app-error-message>
          </div>
        </div>
        <div class="col-md-6 col-lg-3">
          <div class="form mb-0">
            <label for="" class="label"> Reporte hasta </label>
            <app-calendar [controlForm]="dateUntilReport"></app-calendar>
            <app-error-message [text]="controlDateEndError"></app-error-message>
          </div>
        </div>
        <div class="col-12">
          <p class="txt txt--small mt-1">
            *Las fechas corresponden al momento en que fue generada la licencia
          </p>
        </div>
      </div>
    </div>
    <div class="col-12 mt-2">
      <div class="row p-0">
        <div class="col-12 mb-3">
          <p class="mb-2 txt txt--paragraph txt--grey">
            <strong>Filtros de búsqueda</strong>
          </p>
          <p class="mb-2 txt txt--paragraph txt--grey">
            Selecciona las opciones en cada filtro de búsqueda para acotar los
            resultados.
          </p>
        </div>
        <div class="col-md-4 col-lg-4">


          <app-filter-checkbox [filterResult]="filterResult" filterTitle="Asset" [itemControls]="assetsListsControl"
            [gettingItemsList]="gettingItemsList" [gettingItemsListError]="gettingItemsListError"
            [itemsList]="assetList" [listFilterAll]="listFilterAllAssetToRequest">
          </app-filter-checkbox>
        </div>
        <div class="col-md-4 col-lg-4">


          <app-filter-checkbox [filterResult]="filterResult" filterTitle="Tipo de solicitud"
            [itemControls]="typeRequestListsControl" [gettingItemsList]="gettingItemsList"
            [gettingItemsListError]="gettingItemsListError" [itemsList]="typeRequestList"
            [listFilterAll]=" listFilterAllTypeRequest">
          </app-filter-checkbox>
        </div>
        <div class="col-md-4 col-lg-4">


          <app-filter-checkbox [filterResult]="filterResult" filterTitle="Estado de solicitud"
            [itemControls]="stateRequestListsControl " [gettingItemsList]="gettingItemsList"
            [gettingItemsListError]="gettingItemsListError" [itemsList]="stateRequestList"
            [listFilterAll]="listFilterAllStateRequest">
          </app-filter-checkbox>
        </div>

      </div>
    </div>
    <div class="col-12">
      <button type="button" class="btn btn--primary u-mt20 px-5 js-historial"
        [attr.disabled]="controlForm.valid ? null : true" (click)="onGetDetailReport()">
        Ver reporte
      </button>
    </div>
  </div>
</form>
<div *ngIf="warning">
  <p class="text-warning">
    * Debe Seleccionar al menos una opción de los filtros, para obtener el
    reporte.
  </p>
</div>
<div *ngIf="gettingDetailsLicense" class="loader-wrapper">
  <div class="loader-licenses">
    <app-loader></app-loader>
  </div>
</div >
<div class="results mt-5">
  <app-report-table-requests
    *ngIf="detailRequestsByFilter"
    [detailRequestsByFilter]="detailRequestsByFilter"
    (exportToExcel)="exportToExcel()"
  >
  </app-report-table-requests>
  <div
    class="u-mt30 d-flex justify-content-center justify-content-md-end"
    [ngClass]="{'global-unmount': !detailRequestsByFilter}"
  >
    <div class="paginator">
      <ul>
        <li
          class="paginator__arrow paginator__arrow--back global-hand"
          [ngClass]="{'global-unmount': currentPage === 1}"
        >
          <a (click)="getPreviusPage() "></a>
        </li>
        <li class="paginator__number global-hand" *ngFor="let page of listCountForPages let i =  index"
          [ngClass]=" currentPage ===  i  + 1 ? 'paginator__number--current' :  '' ">
          <a (click)="getGotoNumberPage(i+1)">
            {{page}}
          </a>
        </li>
        <li
          class="paginator__arrow paginator__arrow--next global-hand"
          [ngClass]="{'global-unmount': currentPage === listCountForPages.length}"
        >
          <a (click)=" getNextpage()"></a>
        </li>
      </ul>
    </div>
  </div>
</div>
